/**
 * Display codes for headers — keep in sync with *ColumnDef tables
 * (supplierColumnDef, benefitColumnDef, circuitColumnDef, estimatesColumnDef, clientsColumnDef).
 */

export function formatSupplierCode(code: number): string {
  return `F${code.toString().padStart(4, '0')}`;
}

export function formatBenefitCode(code: number): string {
  return `P${code.toString().padStart(4, '0')}`;
}

export function formatCircuitCode(code?: number | null): string {
  if (code == null || !Number.isFinite(code)) {
    return '';
  }
  return `C${code.toString().padStart(4, '0')}`;
}

/** Devis / estimate ref — matches ESTIMATES_COLUMN_DEF */
export function formatEstimateRef(ref: number): string {
  return `D${ref.toString().padStart(3, '0')}`;
}

/** Client ref — matches CLIENTS_COLUMN_DEF (ref may be string from API) */
export function formatClientRef(ref: number | string): string {
  return `C${String(ref).padStart(4, '0')}`;
}
